(function () {
  var loaded = false;
 
  function loadMouseflow() {
    if (loaded) return;
    loaded = true;
 
    window._mfq = window._mfq || [];
    var mf = document.createElement("script");
    mf.type = "text/javascript";
    mf.defer = true;
    mf.src = "//cdn.mouseflow.com/projects/1741a374-33e1-44f9-a49e-5114c5740c3e.js";
    document.getElementsByTagName("head")[0].appendChild(mf);
  }
 
  function checkAndLoad() {
    if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
      loadMouseflow();
    }
  }
 
  // Consent beschikbaar bij laden
  if (window.Shopify?.customerPrivacy) {
    checkAndLoad();
  } else {
    document.addEventListener('cargoodsConsentReady', function(event) {
      checkAndLoad();
    });
  }
  
  // Consent-update (gebruiker handelt banner later af)
  document.addEventListener('visitorConsentCollected', function(event) {
    checkAndLoad();
  });

})();